import Navbar from '@/pages/home/components/Navbar';
import PropertyTypes from '@/pages/home/components/PropertyTypes';
import Footer from '@/pages/home/components/Footer';
import PageHero from '@/components/feature/PageHero';
import PageTransition from '@/components/feature/PageTransition';
import PageCrossLink from '@/components/feature/PageCrossLink';
import useSEO from '@/hooks/useSEO';
import SchemaOrg from '@/components/feature/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const propertiesSchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: 'Property Types | Higher Standard Global',
  url: `${siteUrl}/properties`,
  description:
    'From urban penthouses to private estates — Higher Standard Global manages a curated range of exceptional residential and commercial properties worldwide.',
  provider: {
    '@type': 'RealEstateAgent',
    name: 'Higher Standard Global',
    url: siteUrl,
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'Property Types', item: `${siteUrl}/properties` },
    ],
  },
};

export default function PropertiesPage() {
  useSEO({
    title: 'Property Types | Higher Standard Global — Luxury Real Estate Management',
    description:
      'From urban penthouses to private estates, Higher Standard Global manages a curated range of exceptional residential and commercial properties. Premium property management by referral only.',
    keywords: 'luxury property management, penthouse management, private estate management, vacation property management, premium residential properties',
    canonical: '/properties',
  });

  return (
    <main className="w-full min-h-screen">
      <SchemaOrg schema={propertiesSchema} id="schema-properties" />
      <Navbar />
      <PageHero
        eyebrow="Portfolio"
        title="Property Types"
        subtitle="From urban penthouses to private estates — we manage a curated range of exceptional residential and commercial properties."
        imageUrl="https://public.readdy.ai/ai/img_res/8a38be556558fda8e191feb311c22cb4.jpg"
        ctaLabel="Explore Our Services"
        ctaPath="/services"
      />
      <PageTransition label="What We Manage" />
      <PropertyTypes />
      <PageCrossLink
        prev={{
          label: 'Our Services',
          eyebrow: 'What We Do',
          description: 'The full suite of disciplines we bring to every property engagement.',
          path: '/services',
        }}
        next={{
          label: 'Our Team',
          eyebrow: 'The Principals',
          description: 'Meet the individuals behind Higher Standard Global — by introduction only.',
          path: '/team',
        }}
      />
      <Footer />
    </main>
  );
}
